import moment from 'moment';
import Vue from 'vue';
import util, {calculator} from "@/lib/util";
import AppConsts from "@/lib/appconst";

/**
 * @描述：自定义focus组件
 */
Vue.directive('focus', {
    inserted(el) {
        el.focus();
    }
});

/**
 * @描述：限制字数
 */
Vue.directive('wordLimit', (el, binding, vNode) => {
    let textContent = el.textContent || '';
    let limitNum = binding.value || 150;
    if (textContent.length > limitNum) {
        el.title = textContent;
        textContent = `${textContent.slice(0, limitNum - 1)}...`;
    }

    el.textContent = textContent;
});

/**
 * 日期过滤器
 */
Vue.filter('formatDate', function (value, dateFormat = "YYYY-MM-DD") {
    if (!value) return '';
    return util.formatDate(value,dateFormat);
});

/**
 * 日期过滤器
 */
Vue.filter('formatTime', function (value, dateFormat = "YYYY-MM-DD HH:mm:ss") {
    if (!value) return '';
    return util.formatDate(value,dateFormat);
});

//保留小数位数
Vue.filter('toFixed', function (value, digit: number = 2) {
    let curVal = Number(value);
    if (isNaN(curVal)) {
        return 0;
    }

    if (digit) {
        return curVal.toFixed(digit);
    }

    return curVal;
});

/**
 * @描述：单位转换过滤器
 * @作者: 张俊
 * @创建时间: 2020-03-20 11:47:33
 */
Vue.filter('unitAdapter', function (value, toUnit?: string, unit?: string, rate?: number, digit: number = 2) {
    let curVal = Number(value);
    if (isNaN(curVal)) {
        return value;
    }

    if (rate) {
        return calculator.times(curVal, rate || 1);
    }

    let result = util.unitConversion(curVal, toUnit, unit);
    if (digit) {
        result = Number(result.toFixed(digit));
    }

    return result;
});

//清除html标签
Vue.filter('removeHtml', function (value: string) {
    value = util.removeHtml(value);
    return value;
});

/**
 * @描述：字符串截取
 */
Vue.filter('wordLimit', function (value: string = '', limitNum: number = 150) {
    if(value){
        if (value.length > limitNum) {
            value = `${value.slice(0, limitNum - 1)}...`;
        }
    }

    return value;
});

